<template>
  <div class="order-payment-info">
    <BaseElForm
      label-width="150px"
      label-position="left"
    >
      <BaseElFormItem v-if="paymentConditionType === 'deposit'" :label="$t('orderPubAptPaymentBlock.status.title')">
        <Tag v-if="orderDepositData" style="display: inline-flex" :type="depositPaymentStatus(orderDepositData.status, 'tag')">{{ $t(depositPaymentStatus(orderDepositData.status, 'label')) }}</Tag>
      </BaseElFormItem>
      <BaseElFormItem :label="$t('orderPubAptPaymentBlock.orderTotalPrice.title')">
        {{ orderTotalPrice }}
      </BaseElFormItem>
      <BaseElFormItem :label="depositLabel">
        {{ depositTotalPrice }}
      </BaseElFormItem>
      <BaseElFormItem v-if="paymentConditionType === 'cardSecret' && orderStatus === 'absence'" :label="$t('orderPubAptPaymentBlock.paymentStatus.title')">
        <Tag v-if="orderDepositData" style="display: inline-flex" :type="paymentStatus(orderDepositData.status, 'tag')">{{ paymentStatus(orderDepositData.status, 'label') }}</Tag>
      </BaseElFormItem>
      <BaseElFormItem v-if="paymentConditionType === 'cardSecret' && orderStatus === 'absence'" :label="$t('orderPubAptPaymentBlock.paidAt.title')">
        {{ paidAt }}
      </BaseElFormItem>
      <BaseElFormItem v-if="paymentConditionType === 'cardSecret' && ['complete', 'wait'].includes(orderStatus)" :label="$t('orderPubAptPaymentBlock.lastPaymentDate.title')">
        {{ lastPaymentDate }}
        <p v-if="showPaymentIntimeWarning" class="text-sm text-gray-80 leading-normal">{{ $t('orderPubAptPaymentBlock.paymentIntimeWarning.title') }}</p>
        <p v-if="showPaymentOvertimeWarning" class="text-sm text-gray-80 leading-normal">{{ $t('orderPubAptPaymentBlock.paymentOvertimeWarning.title') }}</p>
      </BaseElFormItem>
      <BaseElFormItem :label="$t('orderPubAptPaymentBlock.paymentType.title')">
        {{ depositPaymentType }}
      </BaseElFormItem>
    </BaseElForm>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { get } from 'lodash'
import { formatDate, addDays } from '@/utils/date'
import { paymentStatusConfig, depositPaymnetStatusConfig } from '@/config/pubApt'
import { i18n } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'OrderPubAptPaymentBlock',
  props: {
    reservation: {
      type: Object,
      default: () => ({}),
    },
    index: Number,
  },
  setup (props) {
    const AppointmentVisitorPreOrder = computed(() => get(props.reservation, 'AppointmentOrder.AppointmentVisitorPreOrder'))
    const paymentConditionType = computed(() => get(AppointmentVisitorPreOrder.value, 'paymentConditionType')) // 'none', 'deposit', 'cardSecret'
    const start = computed(() => get(props.reservation, 'AppointmentOrder.start'))
    // 最晚可扣款日期 ＝ 預約時間 + 7天
    const lastPaymentDate = computed(() => addDays(start.value, 7))
    const orderTotalPrice = computed(() => {
      const price = get(props.reservation, 'AppointmentOrder.totalPrice')
      if (!price) return '-'
      return `$ ${price}`
    })
    const orderStatus = computed(() => get(props.reservation, 'AppointmentOrder.status'))
    const depositLabel = computed(() => paymentConditionType.value === 'deposit' ? i18n.t('orderPubAptPaymentBlock.depositPrice.title') : i18n.t('orderPubAptPaymentBlock.cardSecretPrice.title'))
    const orderDepositData = computed(() => {
      if (paymentConditionType.value === 'deposit') {
        return get(AppointmentVisitorPreOrder.value, 'DepositPubAptPaymentOrder')
      } else if (paymentConditionType.value === 'cardSecret') {
        return get(AppointmentVisitorPreOrder.value, 'PenaltyPubAptPaymentOrder') || get(AppointmentVisitorPreOrder.value, 'CardSecretPubAptPaymentOrder')
      }
      return null
    })
    const paidAt = computed(() => {
      if (orderDepositData.value && get(orderDepositData.value, 'status') !== 'pending') {
        return formatDate(get(orderDepositData.value, 'paidAt'))
      }
      return '-'
    })
    const depositPaymentType = computed(() => {
      if (orderDepositData.value) {
        return get(orderDepositData.value, 'PubAptPaymentConfig.displayName')
      }
      return get(AppointmentVisitorPreOrder.value, 'CardSecretPubAptPaymentOrder.PubAptPaymentConfig.displayName') || '-'
    })
    const depositTotalPrice = computed(() => {
      const paymentConditionAmount = get(AppointmentVisitorPreOrder.value, 'paymentConditionAmount')
      if (paymentConditionAmount) {
        return `$ ${paymentConditionAmount}`
      }
      return '-'
    })
    const showPaymentWarning = computed(() => {
      return paymentConditionType.value === 'cardSecret' && orderStatus.value !== 'wait'
    })
    const showPaymentIntimeWarning = computed(() => {
      return formatDate(new Date()) < lastPaymentDate.value && showPaymentWarning.value
    })
    const showPaymentOvertimeWarning = computed(() => {
      return formatDate(new Date()) > lastPaymentDate.value && showPaymentWarning.value
    })
    const paymentStatus = (status, attr) => {
      return get(paymentStatusConfig[status], attr)
    }
    const depositPaymentStatus = (status, attr) => {
      return get(depositPaymnetStatusConfig[status], attr)
    }
    return {
      paymentConditionType,
      lastPaymentDate,
      orderTotalPrice,
      orderDepositData,
      depositTotalPrice,
      depositPaymentType,
      depositLabel,
      showPaymentIntimeWarning,
      showPaymentOvertimeWarning,
      paymentStatus,
      depositPaymentStatus,
      orderStatus,
      paidAt,
    }
  },
  data: () => ({
    refundDialogType: 'wallet',
  }),
})
</script>

<style lang="postcss" scoped>
</style>
